import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

interface EditDialogProps {
  open: boolean;
  title: string;
  name: string;
  onConfirm: (name: string) => void;
  onClose: () => void;
}

const EditDialog: React.FC<EditDialogProps> = ({
  open,
  title,
  name,
  onConfirm,
  onClose,
}) => {
  const [value, setValue] = useState<string>(name);


  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth={"md"}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{paddingTop: '20px !important'}}>
        <TextField fullWidth id="outlined-basic" label="New name" variant="outlined" defaultValue={name} onChange={(e) => setValue(e.currentTarget.value)} onKeyDown={(e) => { if (e.key === 'Enter') onConfirm(value); }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="success" onClick={() => onConfirm(value)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialog;
